import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { store } from "state";
import { hideMenuButtons, openMenu } from "components/header";

import { SiteSearchContainer } from "./containers";
import { urlService } from "services";
import { Single } from "types";

(() => {
  const searchContainer = document.querySelector<HTMLElement>(
    "[data-site-search]"
  );

  if (!searchContainer) return;

  // initial path = path where the search was triggered
  // initial path is restored after search is closed
  const initPath = window.location.pathname + window.location.search;
  const rootSearchUrl = urlService.getSinglePath(Single.search); // search single url

  const pathIsSearchUrl = initPath.includes(rootSearchUrl);

  const searchProps = {
    redirectPath: initPath,
  };

  // if we're already on a /search path
  // force open menu
  if (pathIsSearchUrl) {
    openMenu();
  }

  // hide close/open buttons when url is /search
  if (initPath === rootSearchUrl) {
    hideMenuButtons();
  }

  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          {/* Match route with search params in URL and all routes */}
          {/* Because we want to render the search on all pages */}
          <Route
            exact={false}
            path={[urlService.searchUrlPattern, "/"]}
            component={() => <SiteSearchContainer {...searchProps} />}
          />
        </Switch>
      </BrowserRouter>
    </Provider>,
    searchContainer
  );
})();
